import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import * as reportService from "../../../services/report.service";
import "react-datepicker/dist/react-datepicker.css";
import Chart from "react-apexcharts";
import { formatDateToString } from "../../../utils/common";
import LoadingIcon from "../../../components/LoadingIcon";
import { useDispatch } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import { clearState } from "../../../redux/actions/authActions";

export default function SubsDayChart({accessToken}) {
  
  const now = new Date();
  const [date, setDate] = useState(now);
  const [data, setData] = useState([]);
  const [noData, setNoDate] = useState(true);
  const dayHours = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23,
  ];
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const structureData = (data) => {
    let newChartData = new Array(24).fill(0);
    data.forEach((dataRow, index) => {
      newChartData[index] = dataRow.count;
    });
    return newChartData;
  };

  const series = [
    {
      name: "Zain Subscribers",
      data: data,
    },
  ];

  const options = {
    chart: {
      height: 350,
      type: "line",
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      events: {
        mounted: function () {
          createReport(formatDateToString(date));
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
    },
    title: {
      text: "Users subscriptions by day",
      align: "left",
      style: {
        fontFamily: "Segoe UI",
        fontWeight: 600,
      },
    },
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"],
        opacity: 0.5,
      },
    },
    xaxis: {
      type: "time",
      categories: dayHours,
    },
    yaxis: {
      tickAmount: undefined,
      type: "count",
      categories: data.count,
    },
  };

  const createReport = () => {
    if (date) {
      reportService
        .subscriptionsByDate(formatDateToString(date), accessToken)
        .then((repsonse) => {
          if (repsonse.status===200) {
            setData(structureData(repsonse.data.data));
            setNoDate(false);
          } else {
            console.log(repsonse);
            setNoDate(true);
          }
         
        })
        .catch((error) => {
          console.log(error)
          if(error.response.status===401) {
                console.log(error.repsonse);
                dispatch(clearState())
              }
          })
    }
  };

  useEffect(() => {
    createReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date]);

  return (
    <>
      <div className="flex">
        <DatePicker
          selected={date}
          onChange={(date) => setDate(date)}
          wrapperClassName="date-picker-wrapper"
        />
      </div>
      <div className="mt-4">
        {noData ? (
          <div className="relative block w-full border-2 border-gray-300 border-dashed rounded-lg p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="mx-auto h-12 w-12 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
              />
            </svg>
            <span className="mt-2 block text-sm font-medium text-gray-900">
              No data for the specified date range.
            </span>
          </div>
        ) : (
          data &&
          data.length > 0 &&
          loading && (
            <>
              {/* <CustomChart series={series} options={options} /> */}
              <Chart
                options={options}
                series={series}
                type="line"
                height={350}
              />
            </>
          )
        )}
      </div>
    </>
  );
}
